<div
  class="popover-arrow"
  [ngClass]="arrowClass"
  [style.left]="arrowLeftPosition + 'px'"
></div>

<div #container class="container">
  <div
    #popover
    class="popover"
    [ngClass]="popoverClass"
    [style.left]="popoverLeftPosition + 'px'"
  >
    <ng-content></ng-content>
  </div>
</div>
